/**
 * Static list of playing card manufacturer URL slugs.
 *
 * This list is used by both middleware and page components to determine
 * if a URL segment is a manufacturer without requiring GraphQL queries.
 *
 * When adding a new manufacturer:
 * 1. Add the urlStub to this array
 * 2. No other code changes needed - middleware and page will automatically support it
 */
export const PLAYING_CARD_MANUFACTURER_SLUGS = [
  'vanishinginc',
  'TCCPresents',
  'theory11',
  'TheBlueCrown',
  'TCCPLAYINGCARDSCOLIMITED',
  'Gemini',
  'RiffleShuffle',
  'ConjuringArtsResearchCenter',
] as const

/**
 * Type helper for manufacturer slugs
 */
export type PlayingCardManufacturerSlug =
  (typeof PLAYING_CARD_MANUFACTURER_SLUGS)[number]

/**
 * Checks if a slug is a known playing card manufacturer
 */
export const isManufacturerSlug = (slug: string): boolean => {
  const normalizedSlug = slug.toLowerCase()

  return PLAYING_CARD_MANUFACTURER_SLUGS.some(
    manufacturerSlug => manufacturerSlug.toLowerCase() === normalizedSlug
  )
}
